import React, { Component, Fragment, useEffect, useState } from 'react';
import { NavMenu } from '../../Controls/NavMenu';

import './Resources/css/site.css';

import Top from './Blocks/Top';
import About from './Blocks/About';
import Footer  from './Blocks/Footer';
import AppWrapper from '../../Controls/Scafolding/AppWrapper';
import Common from '../../Shared/Common';
import { MembersWrapper } from '../../Controls/Branded/Diving/Mem/MembersWrapper';

export class SSD extends Component {

    constructor(props) {
        super(props);
        Common.log('Component Init -> /SSD Landing');

        let logoImagePath = require("./Resources/Images/logo.png");
        //let logoIconPath = require("./Resources/Images/logo.ico");

        this.state = {
            brandCode: 'SSD',

            menu: {

                hasLogo: true,
                logoUrl: logoImagePath,
                logoWidth: '250px',

                styles: {},
                insertBars: false,

                text: 'Sans Souci Dolphins Spearfishing Club',
                textSmallDisplay: 'SS Dolphins',
                //icon: logoIconPath,

                items: [
                    { linkLabel: 'about',   linkUrl: '#about' },
                    { linkLabel: 'contact', linkUrl: '#contact' },
                    { linkLabel: 'Members', linkUrl: '/Members/Home', hardLink : true },
                    { linkLabel: 'Comps', linkUrl: '/Competitions/Home', hardLink : true },
                ],
            }
        };
    }

    render() {
        return (
            <AppWrapper wrapClass="ssd">
                <NavMenu menu={this.state.menu} offset="50" addClass="Menu sticky-top" />

                <Top />
                <About />

                <Footer />
            </AppWrapper>
        );
    }
}

export const SSDMembers = (props) => {

    let logoImagePath = require("./Resources/Images/logo.png");

    const [menu, setMenu] = useState({

        hasLogo: true,
        logoUrl:  logoImagePath,
        logoWidth: '250px',

        styles: {},
        insertBars: false,

        text: 'SSD Memberships',
        textSmallDisplay: 'Memberships',

        items: [
            { linkLabel: 'Me', linkUrl: '/Member', hardLink: true },
            { linkLabel: 'Shop', linkUrl: '/Member', hardLink: true },
        ],
    });

    return (

        <AppWrapper wrapClass="ssd">
            <NavMenu menu={menu} offset="50" addClass="Menu sticky-top" />
            <Top />
            <MembersWrapper />
            {props.children}
            <Footer />
        </AppWrapper>
    );
}

export const SSDComps = (props) => {

    let logoImagePath = require("./Resources/Images/logo.png");

    const [menu, setMenu] = useState({

        hasLogo: true,
        logoUrl: logoImagePath,
        logoWidth: '250px',

        styles: {},
        insertBars: false,

        text: 'SSD Competitions',
        textSmallDisplay: 'Competitions',

        items: [
            { linkLabel: '2026 Comps', linkUrl: '/Competitions/ClubLeaderBoard', hardLink:true },
            { linkLabel: 'Club Records', linkUrl: '/Competitions/ClubRecords', hardLink:true },
            { linkLabel: 'Club Comps History', linkUrl: '/Competitions/ClubCompsResults', hardLink:true },
            { linkLabel: 'Pucko Award', linkUrl: '/Competitions/ThePucko', hardLink: true },
            { linkLabel: 'USFA Records', linkUrl: '/Competitions/NationalResults', hardLink: true },
        ],
    });

    return (

        <AppWrapper wrapClass="ssd">
            <NavMenu menu={menu} offset="50" addClass="Menu sticky-top" />
            <Top />
            {props.children}
            <Footer />
        </AppWrapper>
    );
}



